import { courseItemCodec, courseSectionCodec } from '@/services/api/resources/trainings/course-item/codec';
import * as t from 'io-ts';
import { authorizedTo, id, links, meta } from '@/services/api/response/types';

export const courseCodec = t.type({
  id,
  title: t.string,
  description: t.union([t.string, t.null]),
});

export const courseAuthorizedCodec = t.intersection([
  courseCodec,
  t.type({
    authorizedTo,
  }),
]);

export const coursesListCodec = t.type({
  data: t.array(courseAuthorizedCodec),
  meta,
  links,
});

export const coursePlainCodec = t.type({
  id,
  title: t.string,
  description: t.union([t.string, t.null]),
  items: t.array(courseItemCodec),
});

export const courseTreeCodec = t.type({
  id,
  title: t.string,
  description: t.union([t.string, t.null]),
  items: t.array(t.union([courseItemCodec, courseSectionCodec])),
});
